<div class="color-delete-blocked-modal">
  <p class="blocked-message">
    No se puede eliminar este color porque está asociado a los siguientes productos. Desasocia el color de todos ellos antes de eliminarlo.
  </p>

  <ul class="product-list">
    @for (product of data.products; track product) {
      <li>{{ product }}</li>
    }
  </ul>

  <div class="blocked-actions">
    <button type="button" class="btn btn-primary" (click)="onClose()">Entendido</button>
  </div>
</div>
